import { NavLink } from 'react-router-dom'
import { Icon } from '../Icon'
import { UnreadBadge } from './UnreadBadge'
import { sidebarClasses } from './styles'
import type { NavItem } from '../../constants/sideBar'

type SideBarNavItemProps = {
  item: NavItem
  /** 解決済みの遷移先（組織スコープ付きパス）。未指定なら item.to を使う */
  to?: string
  badgeCount?: number
}

export function SideBarNavItem({ item, to, badgeCount }: SideBarNavItemProps) {
  return (
    <NavLink
      to={to ?? item.to}
      className={({ isActive }) =>
        sidebarClasses.navButton({ isActive })
      }
    >
      {({ isActive }) => (
        <>
          <span className="flex items-center gap-3">
            <Icon
              icon={item.icon}
              className={sidebarClasses.navIcon(isActive)}
            />
            <span>{item.label}</span>
            <UnreadBadge count={badgeCount} className="ml-2" />
          </span>
          <span className={sidebarClasses.navStatus(isActive)} />
        </>
      )}
    </NavLink>
  )
}
